import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=6d21a1c3&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=6d21a1c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d21a1c3",
  null
  
)

export default component.exports